<!-- @format -->

<template>
    <div class="d-flex align-center gst-bonus-points-chip">
        <LogoSmallIcon class="gst-bonus-points-chip__icon" />
        <div class="gst-bonus-points-chip__title ml-1">
            {{
                $t(!redeemPointsToggle ? '_common:terms.earn' : '_common:terms.redeem') +
                ' ' +
                $t('shared:common.pointWithCount', {
                    count: points,
                    formattedCount: formattedPoints,
                })
            }}
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import LogoSmallIcon from '@tenant/app/components/LogoSmallIcon.vue';

export default {
    name: 'BonusPointsChip',
    i18nOptions: {
        namespaces: 'shared',
        keyPrefix: 'components.bonusPoints.bonusPointsChip',
    },
    components: {
        LogoSmallIcon,
    },
    props: {
        points: {
            type: Number,
            required: true,
        },
    },
    computed: {
        ...mapGetters({
            redeemPointsToggle: 'appState/getRedeemPointsToggle',
            userIsAuth: 'user/isAuth',
        }),
        formattedPoints() {
            return this.$options.filters.bonusPoints(this.points);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@scssVariables';
@import '@scssMixins';

.gst-bonus-points-chip {
    .gst-bonus-points-chip__title {
        font-size: font-size('xxs');
        font-weight: font-weight('medium');
    }
}
</style>
